__turbopack_context__.v({
  "backDesktop": "AuthFormBack-module-scss-module__0y1aFG__backDesktop",
  "backMobile": "AuthFormBack-module-scss-module__0y1aFG__backMobile",
  "root": "AuthFormBack-module-scss-module__0y1aFG__root",
});
